<template>
  <div>
    <div class="main-pic">
      <img src="../../assets/image/mobile/mb-about.jpg"/>
    </div>
    <div class="ab-content">
      <div class="ab-title">定制开发找蓝猿</div>
      <div class="ab-text-1">
        <div>
          <p>蓝猿BLUEAPE致力于微信小程序设计开发，微信公众</p>
          <p>平台开发与代运营，品牌网站开发设计，app开发设计，专</p>
          <p>注创意，新颖，品质，捕捉时代热点加以创新开发。</p>
        </div>
        <p>团队每一员都抱着热忱的心对待每个新事物，专注，专心，</p>
        <p>专致，只为打造出每一款时代的科技新事物!</p>
      </div>
      <div class="ab-text-2">
        这是一群90后青年创作团队，新科技，新生活，
        新未来，是我们一直坚持的理念。
      </div>
      <div class="about-box-container">
        <div class="about-box" v-for="(item,key) in aboutBox" :key="key" :style="key==0||key==1?box1Init:box2Init">
          <div class="ab-box-title">{{item.title}}</div>
          <div class="ab-box-title-en">{{item.title_en}}</div>
          <div class="ab-box-detail">{{item.detail}}</div>
        </div>
      </div>
    </div>
    <mbFooter></mbFooter>
  </div>
</template>

<script>
  import mbFooter from "../../components/mobile/mbFooter";

  export default {
    name: "mobile",
    components: {mbFooter},
    data() {
      return {
        aboutBox: [{
          title: '更加专业',
          title_en: 'Professional',
          detail: `有手艺、懂业务、善创新，并不断要求自己更专业`
        },
          {
            title: '诚意服务',
            title_en: 'Service',
            detail: `站在对方角度思考，以服务赢得口碑，以服务赢得信任`
          }, {
            title: '协作运行',
            title_en: 'Execution',
            detail: `遇问题直接沟通，有结论后高效执行，过程中充分同步、协作`
          }, {
            title: '追求结果',
            title_en: 'Result',
            detail: `持续创造并获取价值，为结果买单`
          }],
        box1Init: {
          top: "36vw",
          transition: "all .5s"
        },
        box2Init: {
          top: "36vw",
          transition: "all 1s"
        },
        timer:''
      }
    },
    mounted() {
      this.timer = setTimeout(this.aboutBoxInit,100)
    },
    methods: {
      aboutBoxInit() {
        this.box1Init.top = "0"
        this.box2Init.top = "0"
      }
    }
  }
</script>

<style scoped>
  .main-pic {
    width: 100vw;
    margin: 0 0 6.2vw;
  }

  .main-pic img {
    width: 100%;
  }

  .ab-content {
    letter-spacing: .02em;
    line-height: 140%;
  }

  .ab-title {
    font-size: 1.125em;
    font-weight: bold;
    text-align: center;
  }

  .ab-text-1 {
    font-size: .75em;
    color: #768087;
    margin: 4.8vw 0 12vw;
    text-align: center;
  }

  .ab-text-1 div {
    margin-bottom: 6vw;
  }

  .ab-text-2 {
    padding: 0 6vw;
    font-size: 1em;
    color: #353535;
    text-align: center;
    margin-bottom: 6.4vw;
  }

  .about-box-container {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-bottom: 5.4vw;
    padding: 0 10vw;
  }

  .about-box {
    /*width: 28vw;*/
    width: 34vw;
    /*height: 34vw;*/
    /*height: 36vw;*/
    background-color: #f5f5f5;
    margin: 0 1.2vw 5.2vw;
    color: #353535;
    padding: 4vw 3.2vw;
    box-sizing: border-box;
    position: relative;
  }

  .ab-box-title {
    font-size: 1em;
    /*padding-left: 4vw;*/
    /*margin-bottom: 4vw;*/
  }

  .ab-box-title-en {
    font-size: .625em;
    /*transform: scale(0.667);*/
    margin-bottom: 1vw;
    /*position: absolute;*/
    /*left: 1vw;*/
    /*top: 8vw;*/
  }

  .ab-box-detail {
    font-size: .75em;
    line-height: 180%;
    /*transform: scale(0.75);*/
    /*position: absolute;*/
    /*left: 1vw;*/
    /*top: 12vw;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/mobile.vue